import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { desligarAnalytics, initAnalytics, paginaVista } from '@/lib/analytics'
import { EVENTO_ABRIR, guardarEscolha, lerEscolha } from '@/lib/consentimentoCookies'

// Aviso de cookies em todas as páginas (23/10/2026). Antes só aparecia na
// página inicial, só tinha "Aceitar" e a medição corria de qualquer forma.
// Compacto de propósito: no telemóvel um aviso grande passava a ser o maior
// elemento do ecrã e atrasava o LCP (ver nota de 07/10/2026 no Index).
export function AvisoCookies() {
  const [aberto, setAberto] = useState(() => lerEscolha() === null)

  useEffect(() => {
    const abrir = () => setAberto(true)
    window.addEventListener(EVENTO_ABRIR, abrir)
    return () => window.removeEventListener(EVENTO_ABRIR, abrir)
  }, [])

  if (!aberto) return null

  const escolher = (medicao: boolean) => {
    guardarEscolha(medicao)
    if (medicao) {
      initAnalytics()
      paginaVista()
    } else {
      desligarAnalytics()
    }
    setAberto(false)
  }

  return (
    <div
      role="region"
      aria-label="Escolha de cookies"
      className="fixed bottom-0 left-0 z-50 w-full bg-slate-900/95 px-4 py-2 text-white shadow-2xl"
    >
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-x-3 gap-y-2">
        <p className="text-xs">
          Usamos cookies essenciais e, se aceitar, de medição (Google Analytics e PostHog).{' '}
          <Link to="/cookies" className="underline text-amber-300 hover:text-amber-200">Saber mais</Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            onClick={() => escolher(false)}
            className="rounded-full border border-slate-400 px-4 py-1.5 text-sm font-semibold text-white hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-amber-300"
          >
            Recusar
          </button>
          <button
            onClick={() => escolher(true)}
            className="rounded-full bg-gradient-to-r from-amber-500 to-orange-500 px-4 py-1.5 text-sm font-semibold text-white hover:from-amber-600 hover:to-orange-600 focus:outline-none focus:ring-2 focus:ring-amber-300"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  )
}
